import React, { useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PolarisIcon from '../PolarisIcon';
import { selectCurrentTableKey, selectDataTableEnableGridViewToggle } from '@/redux/selectors/dataTableSelectors';
import { selectUserPreferences } from '@/redux/selectors/authSelectors';
import { savePreferences } from '@/redux/slices/authSlice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

interface ToggleListGridProps {}

const ToggleListGrid = ({}: ToggleListGridProps) => {
  const dispatch = useAppDispatch();
  const enabled = useAppSelector(selectDataTableEnableGridViewToggle);
  const userPreferences = useAppSelector(selectUserPreferences);
  const tableKey = useAppSelector(selectCurrentTableKey);
  const currentGridView = useMemo(() => {
    return userPreferences[tableKey as keyof typeof userPreferences]?.grid;
  }, [userPreferences, tableKey]);

  const handleClick = (isGridView: boolean) => {
    dispatch(
      savePreferences({
        [tableKey as string]: {
          ...userPreferences[tableKey as keyof typeof userPreferences],
          grid: isGridView
        }
      })
    );
  };

  return enabled ? (
    <>
      <Tooltip title="List View" placement="bottom">
        <IconButton onClick={() => handleClick(false)} color={!currentGridView ? 'primary' : 'default'} sx={{ padding: '4.25px' }}>
          <PolarisIcon icon="list" height={22.5} width={22.5} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Grid View" placement="bottom">
        <IconButton onClick={() => handleClick(true)} color={currentGridView ? 'primary' : 'default'} sx={{ padding: '6px' }}>
          <PolarisIcon icon="grid_outline" height={19} width={19} />
        </IconButton>
      </Tooltip>
    </>
  ) : (
    <></>
  );
};

export default ToggleListGrid;
